import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { getStorage } from '../utils/storageUtil'

import pt from './lang/pt.json'
import zh from './lang/zh-tw.json'

Vue.use(VueI18n)

let lang = getStorage('g2e-lang')

if (!lang || lang.indexOf('zh') !== -1) {
  lang = 'zh'
}

const messages = {
  'zh': {
    ...zh
  },
  'pt': {
    ...pt
  }
}

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'zh', // set fallback locale
  messages,
  silentTranslationWarn: true
})

export default i18n
